(() => {
  const desktopMedia = window.matchMedia('(min-width: 900px)');

  const initializeCard = (card) => {
    if (card.dataset.amoreCardReady === 'true') return;

    const strip = card.querySelector('[data-amore-card-strip]');
    const segments = card.querySelectorAll('[data-amore-card-segments] i');
    const previous = card.querySelector('[data-amore-card-previous]');
    const next = card.querySelector('[data-amore-card-next]');
    const media = card.querySelector('.amore-card__media');
    if (!strip) return;

    card.dataset.amoreCardReady = 'true';

    const scrollToFrame = (index, behavior = 'smooth') => {
      strip.scrollTo({ left: strip.clientWidth * index, behavior });
    };

    const updateSegments = () => {
      const index = strip.clientWidth ? Math.round(strip.scrollLeft / strip.clientWidth) : 0;
      segments.forEach((segment, segmentIndex) => segment.classList.toggle('is-active', segmentIndex === index));
    };

    strip.addEventListener('scroll', updateSegments, { passive: true });
    previous?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      strip.scrollBy({ left: -strip.clientWidth, behavior: 'smooth' });
    });
    next?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      strip.scrollBy({ left: strip.clientWidth, behavior: 'smooth' });
    });

    card.addEventListener('mouseenter', () => {
      if (desktopMedia.matches && segments.length > 1) scrollToFrame(1);
    });
    card.addEventListener('mouseleave', () => {
      if (desktopMedia.matches) scrollToFrame(0);
    });
    card.addEventListener('focusin', () => {
      if (desktopMedia.matches && segments.length > 1) scrollToFrame(1);
    });
    card.addEventListener('focusout', (event) => {
      if (desktopMedia.matches && !card.contains(event.relatedTarget)) scrollToFrame(0);
    });

    media?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      strip.scrollBy({ left: (event.key === 'ArrowLeft' ? -1 : 1) * strip.clientWidth, behavior: 'smooth' });
    });
  };

  const initializeCards = (root = document) => {
    root.querySelectorAll('[data-amore-card]').forEach(initializeCard);
  };

  initializeCards();
  document.addEventListener('shopify:section:load', (event) => initializeCards(event.target));
})();
